import React, { useState, useEffect, memo } from "react"
import { Tooltip } from "antd"
import "./ContactComparator.scss"
const ContactComparator = (props) => {
  const { value, data } = props
  const { field } = props.colDef
  const [display, setDisplay] = useState(null)

  useEffect(() => {
    let source = data.location_data.source
    let mask = data.location_data.mask
    let ctg = data.location_data.ctg

    let sourceVal = null
    let ctgVal = null
    let maskVal = null

    if (source && source[field]) {
      sourceVal = formatContact(source[field])
    }
    if (ctg && ctg[field]) {
      ctgVal = formatContact(ctg[field])
    }
    if (mask && mask[field]) {
      maskVal = formatContact(mask[field])
    }

    let component = processValues(sourceVal, ctgVal, maskVal)
    setDisplay(component)
  }, [value, data])

  const formatContact = ({
    first_name = "",
    middle_name = "",
    last_name = "",
    degrees = "",
    phone = "",
    phone_ext = "",
    email = "",
  }) => {
    let fullName = [first_name, middle_name, last_name]
      .filter((item) => item && item.length > 0)
      .join(" ")
      .trim()
    let fullNameDegree = [fullName, degrees]
      .filter((item) => item && item.length > 0)
      .join(", ")
      .trim()
    let phoneNumber = [phone, phone_ext]
      .filter((item) => item && item.toString().length > 0)
      .join(" ext: ")
      .trim()

    return [fullNameDegree, phoneNumber, email].filter((str) => str && str.length > 0).join("\n")
  }

  const processValues = (source, ctg, mask) => {
    if (mask !== undefined && mask !== null && ctg) {
      // if MASK + CTG data is available
      if (mask == ctg) {
        // if MASK + CTG data is equal
        return getComponent(
          mask,
          "masked",
          "Value Overriden Source Value: " + source + "; MASK value = CTG value",
          true
        )
      } else {
        // if MASK + CTG data is NOT equal
        let maskComponent = getComponent(mask, "masked", "Value Overriden Source Value: " + source, true)
        let ctgComponent = getComponent(ctg, "ctg-only", "CTG value")
        return [maskComponent, ctgComponent]
      }
    } else if (mask !== undefined && mask !== null) {
      // only MASK data
      return getComponent(mask, "masked", "Value Overriden Source Value: " + source, true)
    } else if (ctg && source) {
      // if Source + CTG data is available
      if (ctg == source) {
        // if Source + CTG data is equal
        return getComponent(source, "equal", "Prime value = CTG value")
      } else {
        // if Source + CTG data is NOT equal
        let sourceComponent = getComponent(source, "source-only", "Prime value")
        let ctgComponent = getComponent(ctg, "ctg-only", "CTG Value")
        return [sourceComponent, ctgComponent]
      }
    } else if (source) {
      // if Source data only
      return getComponent(source, "source-only", "Prime value")
    } else if (ctg) {
      // if CTG data only
      return getComponent(ctg, "ctg-only", "CTG Value")
    }
    return null
  }

  const getComponent = (value = "", type, tooltip, showMask = false) => {
    const getColor = (type) => {
      switch (type) {
        case "ctg-only":
          return "contact-comparator-ctg-only"
        case "source-only":
          return "contact-comparator-source-only"
        case "masked":
          return "contact-comparator-masked"
        default:
          return "contact-comparator-default"
      }
    }

    const getTextDecoration = (type) => {
      if (type === "ctg-only") return "ctg-only-text-decoration "
      return "default"
    }

    return (
      <Tooltip title={<div className="contact-comparator-info-container">{tooltip}</div>}>
        <div className={`contact-comparator-text ${getColor(type)} ${getTextDecoration(type)}`}>
          {showMask && <i className="fas fa-eye contact-comparator-mask-icon" />}
          {value}
        </div>
      </Tooltip>
    )
  }

  return <div className="contact-comparator-container">{display}</div>
}

export default memo(ContactComparator)
